import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localePt = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_NO_SUGGESTIONS: 'Estou a trabalhar em novas sugestões para este dashlet. Por favor, clique em atualizar.',
  LABEL_HANA_WIDGET_ERROR_FETCH_BUTTON_REFRESH: 'Atualizar',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Erro ao carregar os dados',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'Não foi possível carregar os dados',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Tentar novamente',
  HANA_WIDGET_ERROR_FETCH_TITLE: 'Erro ao carregar os dados',
  HANA_WIDGET_ERROR_FETCH_DESCRIPTION: 'Não foi possível carregar os dados do gráfico',
  HANA_WIDGET_ERROR_FETCH_BUTTON: 'Tentar novamente',
  HANA_WIDGET_INVALID_DATA_FORMAT: 'Formato de dados inválido'
});
export default localePt;